import GameModel from "../../GameModel";

export default class GameTime extends GameModel {
    constructor() {
        super();

        /**
         * The global turn number.
         * @type {number}
         */
        this.turnNumber = 0;
        /**
         * The global frame number.
         * @type {number}
         */
        this.frameNumber = 0;
        /**
         * Most recent save timestamp.
         * @type {number}
         */
        this.saveTime = 0;
    }

    // resetGameModels() {
    //     this.turnNumber = 0;
    //     this.frameNumber = 0;
    // }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        this.turnNumber = 0;
        this.frameNumber = 0;
        this.saveTime = 0;
    }

    /**
     * @override
     */
    resetForPrestige() {
        this.turnNumber = 0;
        this.frameNumber = 0;
   }

}